import React, { useContext } from 'react'
import gtLogo3 from '../media/gtLogo3.png'
import { Typography } from '@mui/material'
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { GlobalContext } from '../context/GlobalContext';

const loginFooterStyle = {
    backgroundColor: "rgb(255, 255, 255, 0.7)",
    textAlign: "right",
    padding: "15px",
    position: "fixed",
    left: "0",
    bottom: "0",
    height: "20px",
    width: "100%",
    display:"flex",
    justifyContent:"space-between",
    alignItems:"center"
}

export default function Footer(){

    const { language } = useContext(GlobalContext)
    
    return (
        <div>
            <div style={loginFooterStyle}>
                <LangButtonGroup />
                <div style={{display:"flex"}}>
                    <Typography>
                        {language === "FR" ? "Développé par" : "A solution by"}
                    </Typography>
                    <img 
                        src={gtLogo3} 
                        height="22px" 
                        width="130px" 
                        alt="Grant Thornton" 
                        style={{marginLeft:"8px", marginRight:"30px"}}
                    />
                </div>
            </div>
        </div>
    )
}


function LangButtonGroup () {
    
    const { language, setLanguage } = useContext(GlobalContext)

    function handleChange (event, newValue) {
        if (newValue) {
            setLanguage(newValue)
            localStorage.setItem("lang", newValue)
        }
    }
    
    return (
        <ToggleButtonGroup value={language} exclusive onChange={handleChange} style={{height:"25px"}}>
            <ToggleButton value="FR">
                FR
            </ToggleButton>
            <ToggleButton value="EN">
                EN
            </ToggleButton>
        </ToggleButtonGroup>
    )
}